import type { AdvisoryAgendaTemplate, AdvisoryAgendaTemplateLine } from './types'

export type DefaultAgendaTemplate = Readonly<{
  kind: 'default'
  title: string
  items: readonly Readonly<AdvisoryAgendaTemplateLine>[]
}>

export type SavedAgendaTemplate = AdvisoryAgendaTemplate & { kind: 'saved' }

export type AgendaTemplateOption = DefaultAgendaTemplate | SavedAgendaTemplate

const DEFAULT_AGENDA_TEMPLATE: DefaultAgendaTemplate = {
  kind: 'default',
  title: 'Quarterly Business Review',
  items: [
    { title: 'Operating Profitability', description: '' },
    { title: 'Financial Health', description: '' },
    { title: 'Cashflow Analysis', description: '' },
  ],
}

export function agendaTemplateKey(template: AgendaTemplateOption): string {
  return template.kind === 'default' ? 'default' : template.advisoryAgendaTemplateId
}

// The default lives only in the UI until a user saves it, which creates a real record.
// The API has no default flag, so a saved template with the same name is taken as the saved default.
export function withDefaultAgendaTemplate(templates: AdvisoryAgendaTemplate[]): AgendaTemplateOption[] {
  const normalize = (title: string) => title.trim().toLowerCase()
  const saved = templates.map((template): SavedAgendaTemplate => ({ ...template, kind: 'saved' }))
  const alreadySaved = templates.some(
    (template) => normalize(template.title) === normalize(DEFAULT_AGENDA_TEMPLATE.title)
  )
  return alreadySaved ? saved : [DEFAULT_AGENDA_TEMPLATE, ...saved]
}
